module.exports = __webpack_public_path__ + "static/media/296205.9ecf2a27.png";